// export const BASE_URL = 'http://localhost:5000';
export const BASE_URL = 'https://api.art-bazar.am';